import React from 'react'
import PropTypes from 'prop-types'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import Container from '../global/Container'

const PageHeroComponent = ({ slug, data, className }) => {
  
  return (
    <div className={className}>
      <div className={`${slug}-page`}>
        <div className="hero-text">
          <Container>
            <h1>{data.heroTitle}</h1>
          </Container>
        </div>
        <div className="background" 
          style={{
            backgroundImage: `url(${
              data.heroImage.childImageSharp
                ? data.heroImage.childImageSharp.fluid.src
                : data.heroImage
            })`,
          }}
        ></div>
      </div>
    </div>
  )
}

PageHeroComponent.propTypes = {
  slug: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  className: PropTypes.string
}

const PageHero = styled(PageHeroComponent)`
  ${tw`overflow-hidden bg-cover relative w-full`}
  height: 85vh;
  min-height: 450px;
  max-height: 600px;
  .hero-text {
    ${tw`w-full absolute text-white`}
    z-index: 2;
    top: 35%;
    left: 0;
    h1 {
      font-size: 140px;
      line-height: 90%;
      @media (max-width: 1023px) {
        font-size: 100px;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
    }
  }
  .foreground, .background {
    ${tw`overflow-hidden bg-cover absolute w-full`}
    height: 100%;
    top: 0;
  }
  .foreground { z-index: 3; }
  .background { 
    z-index: 1; 
    background-position: center bottom;
  }
  .mailing-list {
    position: absolute;
    bottom: 15vh;
    z-index: 5;
    left: 0;
    width: 100%;
  }
  .mailing-list-form {
    float: right;
  }
  .value-prop .shadow {
    opacity: 0.8;
  }
  .businesses-page .value-prop .shadow .content {
    background-color: #D9CFC7 !important;
  }
  .schools-page .value-prop .foreground .content {
    font-size: 0.9rem;
  }
  .schools-page .value-prop .shadow .content {
    background-color: #00ADEE !important;
  }
`

export default PageHero
